var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8182 0.545455C20.6073 0.163636 19.2764 0 18 0C15.8727 0 13.5818 0.436364 12 1.63636C10.4182 0.436364 8.12727 0 6 0C3.87273 0 1.58182 0.436364 0 1.63636V17.6182C0 17.8909 0.272727 18.1636 0.545455 18.1636C0.654545 18.1636 0.709091 18.1091 0.818182 18.1091C2.29091 17.4 4.41818 16.9091 6 16.9091C8.12727 16.9091 10.4182 17.3455 12 18.5455C13.4727 17.6182 16.1455 16.9091 18 16.9091C19.8 16.9091 21.6545 17.2364 23.1818 18.0545C23.2909 18.1091 23.3455 18.1091 23.4545 18.1091C23.7273 18.1091 24 17.8364 24 17.5636V1.63636C23.3455 1.14545 22.6364 0.818182 21.8182 0.545455ZM21.8182 15.2727C20.6182 14.8909 19.3091 14.7273 18 14.7273C16.1455 14.7273 13.4727 15.4364 12 16.3636V3.81818C13.4727 2.89091 16.1455 2.18182 18 2.18182C19.3091 2.18182 20.6182 2.34545 21.8182 2.72727V15.2727Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 6.54536C18.9599 6.54536 19.8872 6.64354 20.7272 6.829V5.17081C19.8654 5.00718 18.9381 4.909 17.9999 4.909C16.1454 4.909 14.4654 5.22536 13.0908 5.81445V7.62536C14.3235 6.92718 16.0363 6.54536 17.9999 6.54536Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0908 8.71637V10.5273C14.3235 9.82909 16.0363 9.44728 17.9999 9.44728C18.9599 9.44728 19.8872 9.54546 20.7272 9.73091V8.07273C19.8654 7.90909 18.9381 7.81091 17.9999 7.81091C16.1454 7.81091 14.4654 8.13819 13.0908 8.71637Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 10.7238C16.1454 10.7238 14.4654 11.0401 13.0908 11.6292V13.4401C14.3235 12.7419 16.0363 12.3601 17.9999 12.3601C18.9599 12.3601 19.8872 12.4583 20.7272 12.6438V10.9856C19.8654 10.811 18.9381 10.7238 17.9999 10.7238Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReading);
export default __webpack_public_path__ + "static/media/icon_reading.d6b42a38460fa7b7ba8603bf247acd56.svg";
export { ForwardRef as ReactComponent };